
  <div class="modal-body">     
   <div *ngIf="newOrder">
<mat-dialog-title >  
  <button type="button" (click)="onClose()" style="float: right; margin-top: -5%;">X </button>
</mat-dialog-title>
</div>
     <div *ngIf="sectionToShow == 1" class="uploadText">
      <h2 *ngIf="!newOrder" class="note-title">Our NEW Measurement Form Upload is here!</h2>
      <h2 *ngIf="newOrder" class="note-title">Your Measurement Form Upload starts here.</h2>
      <p *ngIf="!newOrder" class="upText">When creating an order, use the Measurement Form Upload button to add your form, or handwritten notes, to your project. Your measurements will be converted and entered into your order for you.</p>
      <p *ngIf="newOrder" class="upText">Use this button to upload your measurement form, or handwritten notes, and let our AI instantly convert them into an editable order.</p>
       <table>
           <tbody>
            <tr>
              <td *ngIf="newOrder" class="downText">Check out <br>our introduction video.</td>
              <td *ngIf="!newOrder" class="downText">Watch video to see how we’re making your job easier.</td>
              <td class="downText">Learn how it works with a step-by-step guide.</td> 
            </tr>
            <tr>
              <td ><a href="javascript:void(0)" (click)="openVideoTutorialModal()"><img class="youImage" src="assets/images/VideoUploadFormImage.jpg" alt=""></a></td>
              <td><a href="https://qwikkit.com/wp-content/uploads/2025/10/Qwikkit-Measurement-Form-Upload-Guide.pdf" target="_blank"><img class="divImage" src="assets/images/ImagePdfLink.jpg" alt="" ></a></td>        
            </tr>
          </tbody>
        </table>        
      </div>      
    </div>   

    <div *ngIf="sectionToShow == 2" class="modal-body">   
      <div [class]="newOrder ? 'youtubeFrame new-order' : 'youtubeFrame old-order'">
        <iframe width="100%" height="500px" src="https://youtube.com/embed/AaOHuUJqqeU" frameborder="0" 
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerpolicy="strict-origin-when-cross-origin"></iframe>
      </div>     
    </div>   

    <div class="getStarted" *ngIf="newOrder">   
       <table >
          <tr>
            <td>
              <p>Get started now!</p>
            </td>
          </tr>
          <tr>
            <td>
             <button type="button" class="buttons" style="width: 100%;"  (click)="onSave();">Measurement Form Upload</button>
            </td>
          </tr>
      </table>
      </div>

